import { supportItems } from '@/mocks/franchiseData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function SupportSystem() {
  return (
    <section className="relative bg-brand-gray py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src={readdy('support-sys-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">支持体系</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                八大支持体系，为门店运营全程护航
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {supportItems.map((item, i) => (
              <ScrollReveal key={item.title} variant="fade-up" delay={i * 60}>
                <div className="bg-white rounded-xl p-5 md:p-6 text-center border border-brand-light/30 hover:border-brand-cream hover:shadow-md transition-all duration-300 cursor-pointer group">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-lg bg-brand-light group-hover:bg-brand-cream transition-colors">
                    <i className={`${item.icon} text-brand-deep text-base`} />
                  </div>
                  <h4 className="text-sm font-semibold text-brand-deep mb-1">{item.title}</h4>
                  <p className="text-gray-400 text-xs">{item.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}